import { ApiError } from "./ApiError"

/**
 * Custom error class for authorization/permission issues
 * Thrown when API requests fail due to insufficient permissions (typically 403 Forbidden)
 */
export class AuthorizationError extends ApiError {
  public readonly originalError?: Error

  constructor(apiError: ApiError, originalError?: Error) {
    super({
      message: apiError.message,
      status: apiError.status,
      statusText: apiError.statusText,
      url: apiError.url,
      body: apiError.body,
      method: apiError.method
    })

    this.name = "AuthorizationError"
    this.originalError = originalError ?? apiError

    // This is needed to make instanceof work correctly with TypeScript
    Object.setPrototypeOf(this, AuthorizationError.prototype)
  }
}
